// Listings
export const SM_ADMIN_GET_LISTINGS_REQUEST = "SM_ADMIN_GET_LISTINGS_REQUEST";
export const SM_ADMIN_GET_LISTINGS_SUCCESS = "SM_ADMIN_GET_LISTINGS_SUCCESS";
export const SM_ADMIN_GET_LISTINGS_FAIL = "SM_ADMIN_GET_LISTINGS_FAIL";

export const SM_ADMIN_GET_LISTING_DETAIL_REQUEST = "SM_ADMIN_GET_LISTING_DETAIL_REQUEST";
export const SM_ADMIN_GET_LISTING_DETAIL_SUCCESS = "SM_ADMIN_GET_LISTING_DETAIL_SUCCESS";
export const SM_ADMIN_GET_LISTING_DETAIL_FAIL = "SM_ADMIN_GET_LISTING_DETAIL_FAIL";

export const SM_ADMIN_APPROVE_LISTING_REQUEST = "SM_ADMIN_APPROVE_LISTING_REQUEST";
export const SM_ADMIN_APPROVE_LISTING_SUCCESS = "SM_ADMIN_APPROVE_LISTING_SUCCESS";
export const SM_ADMIN_APPROVE_LISTING_FAIL = "SM_ADMIN_APPROVE_LISTING_FAIL";

export const SM_ADMIN_REJECT_LISTING_REQUEST = "SM_ADMIN_REJECT_LISTING_REQUEST";
export const SM_ADMIN_REJECT_LISTING_SUCCESS = "SM_ADMIN_REJECT_LISTING_SUCCESS";
export const SM_ADMIN_REJECT_LISTING_FAIL = "SM_ADMIN_REJECT_LISTING_FAIL";

// Transactions
export const SM_ADMIN_GET_TRANSACTIONS_REQUEST = "SM_ADMIN_GET_TRANSACTIONS_REQUEST";
export const SM_ADMIN_GET_TRANSACTIONS_SUCCESS = "SM_ADMIN_GET_TRANSACTIONS_SUCCESS";
export const SM_ADMIN_GET_TRANSACTIONS_FAIL = "SM_ADMIN_GET_TRANSACTIONS_FAIL";

// Config
export const SM_ADMIN_GET_CONFIG_REQUEST = "SM_ADMIN_GET_CONFIG_REQUEST";
export const SM_ADMIN_GET_CONFIG_SUCCESS = "SM_ADMIN_GET_CONFIG_SUCCESS";
export const SM_ADMIN_GET_CONFIG_FAIL = "SM_ADMIN_GET_CONFIG_FAIL";

export const SM_ADMIN_UPDATE_CONFIG_REQUEST = "SM_ADMIN_UPDATE_CONFIG_REQUEST";
export const SM_ADMIN_UPDATE_CONFIG_SUCCESS = "SM_ADMIN_UPDATE_CONFIG_SUCCESS";
export const SM_ADMIN_UPDATE_CONFIG_FAIL = "SM_ADMIN_UPDATE_CONFIG_FAIL";

// Dashboard
export const SM_ADMIN_DASHBOARD_REQUEST = "SM_ADMIN_DASHBOARD_REQUEST";
export const SM_ADMIN_DASHBOARD_SUCCESS = "SM_ADMIN_DASHBOARD_SUCCESS";
export const SM_ADMIN_DASHBOARD_FAIL = "SM_ADMIN_DASHBOARD_FAIL";
